export default "__VITE_ASSET__Dwsb4jKm__"